(ns common.schema.entities.oppo.core
  (:require [common.schema.entities.oppo.permissions :as permissions]
            [common.schema.entities.oppo.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/oppo
   :schema                       schema/schema
   :name                         {:en "Deal"}
   :plural                       {:en "Deals"}
   :icon                         :fa-handshake

   :display-name-fn              (fn [{:keys [entity]}]
                                   (:oppo/name entity))
   :display-name/depends-on      [:oppo/name]

   :search                       {:result/title-attr     :oppo/name
                                  :result/subtitle-attrs [:oppo/status
                                                          :oppo/stage]
                                  :indexing              {:change-listening?         true
                                                          :dedicated-index?          true
                                                          :select-searchable?        true
                                                          :associated-entity-fields  #{:oppo/target-asset}
                                                          :name-field                "extras.full-name"
                                                          :universal-filters         {[:extras :pipeline] {:type "number"}}
                                                          :show-in-universal-search? true}
                                  :list/default-columns  [:oppo/name
                                                          :oppo/cur-ticket
                                                          :oppo/stage
                                                          :oppo/status
                                                          :oppo/status-and-next-steps
                                                          :oppo/owner]
                                  :list/default-sort     [:oppo/name :asc]
                                  :quick-filters         [:oppo/status
                                                          :oppo/stage]
                                  :views                 {:grid   {:po-default-field-paths [[:oppo/name]
                                                                                            [:oppo/cur-ticket]
                                                                                            [:oppo/stage]
                                                                                            [:oppo/status]
                                                                                            [:oppo/status-and-next-steps]
                                                                                            [:oppo/owner]]
                                                                   :mandatory-field-paths  [[:oppo/name]]
                                                                   :pinned-field-paths     {:left [[:oppo/name]]}}
                                                          :kanban {:group-by-field :oppo/stage
                                                                   :card           {:header-fields [:oppo/name]
                                                                                    :body-fields   [:oppo/cur-ticket
                                                                                                    :oppo/status
                                                                                                    :oppo/status-and-next-steps
                                                                                                    :oppo/owner]
                                                                                    :footer-fields [:common/updated-on]
                                                                                    :meta-fields   [:oppo/status]}}}}

   :reporting                    {:export/default-fields
                                  [:oppo/name
                                   :oppo/cur-ticket
                                   :oppo/stage
                                   :oppo/status
                                   :common/created-on
                                   :common/updated-on]
                                  :export/filename-template "deals_{{date}}.csv"}

   :permissions                  {:creatable?   true
                                  :disableable? true}

   :mcp                          {:creatable? true}

   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
